import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";

const LABELS = ["Farve", "Størrelse", "Variant"];

export const emptyVariants = () => [
  { name: "", qty: 10, aliases: "" },
  { name: "", qty: 10, aliases: "" },
];

export default function VariantEditor({ label, variants, onChange, onLabel, locked = {} }) {
  const [adv, setAdv] = useState(false);
  const total = variants.reduce((a, x) => a + (Number(x.qty) || 0), 0);
  const upd = (i, k, val) => onChange(variants.map((x, j) => (j === i ? { ...x, [k]: val } : x)));
  return (
    <div className="ve" data-testid="variant-editor">
      <div className="field">
        <label htmlFor="variant_label">Hvad hedder varianterne?</label>
        <select id="variant_label" value={label} onChange={(e) => onLabel(e.target.value)} data-testid="variant-label">
          {LABELS.map((l) => <option key={l}>{l}</option>)}
        </select>
      </div>
      {variants.map((x, i) => (
        <div className="ve-row" key={x.id ?? `n${i}`} data-testid={`variant-row-${i}`}>
          <input aria-label={`${label} ${i + 1} navn`} placeholder={label === "Størrelse" ? "Fx M" : "Fx Rød"} value={x.name}
            onChange={(e) => upd(i, "name", e.target.value)} maxLength={40} data-testid={`variant-name-${i}`} />
          <input aria-label={`${label} ${i + 1} antal`} type="number" min={locked[x.id] || 0} value={x.qty}
            onChange={(e) => upd(i, "qty", e.target.value)} data-testid={`variant-qty-${i}`} />
          <button type="button" className="ck-close" aria-label="Fjern variant" disabled={!!locked[x.id] || variants.length <= 2}
            title={locked[x.id] ? "Har ordrer – sæt antal til det reserverede i stedet" : "Fjern"}
            onClick={() => onChange(variants.filter((_, j) => j !== i))} data-testid={`variant-remove-${i}`}>
            <Trash2 size={16} />
          </button>
          {adv && (
            <input className="ve-alias" aria-label={`${x.name || label} stavemåder`} placeholder="Flere stavemåder, fx rod, rode"
              value={x.aliases} onChange={(e) => upd(i, "aliases", e.target.value)} data-testid={`variant-aliases-${i}`} />
          )}
        </div>
      ))}
      <div className="ve-foot">
        <button type="button" className="btn small" onClick={() => onChange([...variants, { name: "", qty: 0, aliases: "" }])} data-testid="variant-add">
          <Plus size={15} /> Tilføj variant
        </button>
        <button type="button" className="btn small" onClick={() => setAdv((a) => !a)} data-testid="variant-advanced">
          {adv ? "Skjul stavemåder" : "Flere stavemåder"}
        </button>
        <span className="ve-total" data-testid="variant-total">I alt: <b>{total}</b> stk.</span>
      </div>
      <div className="hint">Kunderne skriver fx «ja tak {(variants[0]?.name || "rød").toLowerCase()}» eller «ja tak 2 {(variants[1]?.name || "blå").toLowerCase()}». Samme pris for alle.</div>
    </div>
  );
}
